/**
 * @description scroll 相关方法
 * @created 2024/04/27 13:50:09
 */

/**
 * @description 触底事件
 * @created 2024/04/27 13:50:18
 */
export function onScrollToLower(target, callback, bottom = 60) {
  const { scrollHeight, scrollTop, clientHeight } = target
  const scrollBottom = scrollHeight - scrollTop - clientHeight
  // 触底后
  if (scrollBottom < bottom) {
    callback()
  }
}
